import React from 'react';
import { TcmfGenerator } from './TcmfGenerator';

function App() {
    return (
        <div className="min-h-screen bg-white">
            <TcmfGenerator />
        </div>
    );
}

export default App;